import { render, staticRenderFns } from "./comment-optimiser-le-budget-de-vos-campagnes-facebook-ads.vue?vue&type=template&id=05418369&"
import script from "./comment-optimiser-le-budget-de-vos-campagnes-facebook-ads.vue?vue&type=script&lang=js&"
export * from "./comment-optimiser-le-budget-de-vos-campagnes-facebook-ads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports